import { FilterConditionOutput } from '@shared/components/ui/AdvancedFilter';
import React from 'react';
import { FiltersSection } from '../interaction';

interface LocationsHeaderProps {
  onSearch: (searchTerm: string) => void;
  onFilterChange: (conditions: FilterConditionOutput[]) => void;
  hasTeamData?: boolean;
}

const LocationsHeader: React.FC<LocationsHeaderProps> = ({ onSearch, onFilterChange, hasTeamData = false }) => {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <div className="flex items-center gap-3 flex-wrap">
          <FiltersSection handleSearch={onSearch} onFilterChange={onFilterChange} hasTeamData={hasTeamData} />
        </div>
      </div>
    </div>
  );
};

export default LocationsHeader;
